import React, { useState } from 'react';
import {
  Box,
  Button,
  Container,
  Grid2 as Grid,
  useMediaQuery,
  useTheme
} from '@mui/material';
import Page from 'src/components/Page';
import {websiteTitle} from 'src/config';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import AlertsTable from './AlertsTable';
import { Settings } from 'lucide-react';
import { Link as RouterLink } from 'react-router-dom';
import CreateAlertButton from 'src/components/CreateAlertButton.js'

const useStyles = makeStyles()((theme) => ({
  metalRoot: {
    backgroundColor: 'var(--neutral-1)',
    minHeight: '100%',
    [theme.breakpoints.up('md')]: {
      padding: `0 ${theme.spacing(4)} ${theme.spacing(0.5)}`,
    }
  },
  alertsBtn: {
    color: '#e6e5e8 !important',
    fontSize: '16px',
    textTransform: 'capitalize',
    borderRadius: "var(--radius-md, 8px)",
    border: "1px solid var(--Component-colors-Components-Buttons-Secondary-color-button-secondary-color-border, #364152)",
    background: "var(--Component-colors-Components-Buttons-Secondary-color-button-secondary-color-bg, #121926)",
    boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
    whiteSpace: 'nowrap',
    '&:hover' : {
      textDecoration: "none !important"
    },
  }
}));

const AlertsView = (props) => {
  const [ loading, setLoading] = useState(true);
  const [ noData, setNoData ] = useState(true)
  const { t } = useTranslation();
  const theme = useTheme()
  const { classes } = useStyles();
  const pageTitle = websiteTitle + " - " + t('alerts');
  const mediumDevice = useMediaQuery(theme.breakpoints.down('md'));
  const largeDevice = useMediaQuery(theme.breakpoints.down("lg"));
  const coin = props.coin;

  return (
    <Page
      className={classes.metalRoot}
      title={pageTitle}
    >
      <Container maxWidth="xxl">
        <header className="m-heading has-space-m" style={
          largeDevice
            ? { 
                padding: '0 0 16px 0', 
                position: "relative",
              }
            : {
                padding: 'var(--space-xxl) 0 16px 0', 
                position: "absolute",
                top: "18px",
                right: "58px",
              }
            }>
          <div className="m-stack" style={mediumDevice ? {minHeight:"40px"} : {height: "40px"}}>
            <div 
              style={
                mediumDevice 
                  ? { display: 'flex', flexDirection: "column", alignItems: 'flex-start', justifyContent: 'flex-start'}
                  : { display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                <div style={{flex : 1}}></div>
              {
                !noData && <div style={mediumDevice ? {display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "32px"} : {}}>
                  <Button
                    data-testid="fdr_alert_btn_manage"
                    className={classes.alertsBtn}
                    component={RouterLink}
                    variant='outlined'
                    to='/app/alerts/manage'
                    startIcon={<Settings />}
                  >
                      {t('manageAlerts')}
                  </Button>
                  <CreateAlertButton coin={coin}/>
                </div>
              }
            </div>             
          </div>
        </header>
        <Box mt={mediumDevice ? 0 : 4}>
          <Grid
            justifyContent="center"
            size={12}
          >
            <AlertsTable {...props} setNoData={setNoData} loading={loading} setLoading={setLoading}/>
          </Grid>
        </Box>
      </Container>
    </Page>
  );
};

export default AlertsView;

